'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntypoIcon = function (_React$Component) {
  _inherits(EntypoIcon, _React$Component);

  function EntypoIcon(props) {
    _classCallCheck(this, EntypoIcon);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EntypoIcon).call(this, props));

    _this.state = {
      hovered: false
    };
    return _this;
  }

  _createClass(EntypoIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var style = _props.style;
      var viewBox = _props.viewBox;
      var valign = _props.valign;
      var propClass = _props.propClass;

      var other = _objectWithoutProperties(_props, ['children', 'style', 'viewBox', 'valign', 'propClass']);

      var defaultStyles = {
        display: 'inline-block',
        height: '1em',
        width: '1em',
        fill: 'currentColor',
        userSelect: 'none'
      };

      var verticalAlignment = valign === false ? {} : valign === true ? { verticalAlign: 'middle' } : { verticalAlign: valign };

      var mergedStyles = typeof style === 'undefined' || (typeof style === 'undefined' ? 'undefined' : _typeof(style)) === 'object' ? Object.assign(defaultStyles, verticalAlignment, style) : {};

      var mergedClasses = this.props.className ? propClass + ' ' + this.props.className : propClass;

      return _react2.default.createElement(
        'svg',
        _extends({}, other, {
          className: mergedClasses,
          style: mergedStyles,
          viewBox: viewBox
        }),
        children
      );
    }
  }]);

  return EntypoIcon;
}(_react2.default.Component);

EntypoIcon.defaultProps = {
  viewBox: '0 0 20 20',
  preserveAspectRatio: 'xMidYMid meet',
  valign: 'text-top'
};

EntypoIcon.propTypes = {
  children: _react.PropTypes.node,
  style: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.bool]),
  viewBox: _react.PropTypes.string,
  valign: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
  propClass: _react.PropTypes.string
};

exports.default = EntypoIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/EntypoIcon/index.js
// module id = ./node_modules/react-entypo/lib/EntypoIcon/index.js
// module chunks = 2